import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  LinearProgress,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RedirectKeepUTM } from "../../../shared/components/RedirectKeepUTM";
import { Header } from "../../../shared/components/header";
import { setClose } from "../../../shared/request/actions/requestActions";
import {
  asyncAssignParticipantContent,
  asyncGetFullAssignedContentInfo,
  asyncMarkParticipantContentAsWatched,
  resetEditingAssignedContent,
} from "../../actions/contentActions";
import { Article, MoneyHack, Resource } from "../../components";
import { COMPLETED } from "../../consts/assignedContentStatus";
import { useStyles } from "./styles";

export const ViewAssignedContentDetail = ({ navigation }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { id: assignedContentId } = useParams();

  const {
    request,
    editingAssignedContent,
    editingContent,
    organizationSettings,
  } = useSelector((state) => ({
    request: state.request.request,
    editingAssignedContent: state.content.editingAssignedContent,
    editingContent: state.content.editingContent,
    organizationSettings: state.auth.login.organization.settings,
  }));

  useEffect(() => {
    dispatch(resetEditingAssignedContent());
    if (assignedContentId)
      dispatch(asyncGetFullAssignedContentInfo(assignedContentId));
  }, [dispatch, assignedContentId]);

  const handleChange = (event) => {
    const shouldMarkAsChecked = event.target.checked;
    if (shouldMarkAsChecked) {
      dispatch(asyncMarkParticipantContentAsWatched(editingContent.contentId));
    } else {
      dispatch(asyncAssignParticipantContent(editingContent.contentId));
    }
  };

  const handleMessageClose = () => {
    dispatch(setClose());
  };

  if (organizationSettings?.isContentFunctionalityEnabled === false) {
    return (
      <RedirectKeepUTM
        from={`/assignedContent/${assignedContentId}`}
        to="/participant"
      />
    );
  }

  return (
    <Header navigation={navigation}>
      {request.isFetching && (
        <div className={classes.root}>
          <LinearProgress color="secondary" />
        </div>
      )}
      <Container className={classes.container}>
        <Grid xs={12}>
          <Typography align="right">
            <FormControlLabel
              data-testid="completeCheckbox"
              control={
                <Checkbox
                  checked={editingAssignedContent.statusId === COMPLETED}
                  onChange={handleChange}
                  name="completeCheckbox"
                  color="primary"
                  disabled={
                    request.isFetching ||
                    editingAssignedContent.assignedContentId === 0
                  }
                />
              }
              label="Watched"
            />
          </Typography>
        </Grid>

        <Grid xs={12} container alignItems="center" justifyContent="center">
          {editingContent.contentType === "Money Hack" && (
            <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
              <MoneyHack
                data={editingContent}
                assignedContent={editingAssignedContent}
              />
            </Grid>
          )}
          {editingContent.contentType === "Article" && (
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Article
                data={editingContent}
                assignedContent={editingAssignedContent}
              />
            </Grid>
          )}
          {editingContent.contentType === "Resource" && (
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Resource
                data={editingContent}
                assignedContent={editingAssignedContent}
              />
            </Grid>
          )}
        </Grid>
      </Container>
      <Snackbar
        key="request-message-alert"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={request.isOpen}
        autoHideDuration={6000}
        onClose={handleMessageClose}
      >
        <Alert onClose={handleMessageClose} severity={request.type}>
          {request.message}
        </Alert>
      </Snackbar>
    </Header>
  );
};

ViewAssignedContentDetail.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ViewAssignedContentDetail.defaultProps = {
  navigation: [],
};
